import { useEffect, useState } from "react";
import AddressForm from "../../../molecules/Common/AddressForm";
import {
  Button,
  CircularProgress,
  Grid,
  Icon,
  Typography,
} from "@mui/material";
import LGModal from "../../../molecules/LGModal";
import {
  addClientAddress,
  getClientAddressesList,
} from "../../../api/client";
import ClientAddressCard from "../../../molecules/Common/ClientAddressCard";
import { useSnack } from "../../../services/SnakbarProvider";
import { handleError } from "../../../services/errorHandler";

export default function ClientAddressList({ clientId, companyId }) {
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [addressesList, setAddressesList] = useState([]);

  const { openSnack } = useSnack();

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleAddAddressClick = () => {
    setOpenModal(true);
  };

  const handleSubmitAddress = async (addressPayload) => {
    const payload = { ...addressPayload, clientId, companyId };
    try {
      setLoading(true);
      await addClientAddress(payload);
      await fetchAddresses();
      setOpenModal(false);
      openSnack("Dirección agregada exitosamente", "success");
    } catch (e) {
      openSnack(handleError(e), "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchAddresses = async () => {
    try {
      const res = await getClientAddressesList(clientId);
      setAddressesList(res.data);
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  useEffect(() => {
    if (clientId) {
      fetchAddresses();
    }
  }, [clientId]);

  return (
    <>
      <LGModal
        open={openModal}
        header="Agregar Dirección"
        handleClose={handleModalClose}
      >
        <AddressForm props={{ id: 0, onSubmit: handleSubmitAddress }} />
      </LGModal>
      {loading ? (
        <CircularProgress />
      ) : (
        <Grid
          container
          mt={2}
          spacing={2}
          justifyContent={"left"}
          alignItems={"stretch"}
        >
          <Grid item xs={9}>
            <Typography variant="h5">Direcciones</Typography>
          </Grid>
          <Grid justifySelf={"left"} item xs={3}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              startIcon={<Icon>add</Icon>}
              onClick={handleAddAddressClick}
            >
              Agregar
            </Button>
          </Grid>
          <Grid container spacing={2} item xs={12} alignContent={"stretch"}>
            {addressesList &&
              addressesList.map((e, index) => (
                <Grid item xs={4} key={index}>
                  <ClientAddressCard
                    address={e.address}
                    clientAddressId={e.id}
                    onChange={fetchAddresses}
                  />
                </Grid>
              ))}
          </Grid>
        </Grid>
      )}
    </>
  );
}
